import { motion } from "framer-motion";
import Reveal from "../Reveal";

const U = (base, w = 1400) => `${base}&w=${w}&auto=format&fit=crop`;

export const PE_IMG = {
  hero: U("https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&q=85", 1800),
  experience: U("https://images.unsplash.com/photo-1657563920440-0ac6d8932f20?crop=entropy&cs=srgb&fm=jpg&q=85", 1100),
  facials: U("https://images.unsplash.com/photo-1577746838851-816a43ca8733?crop=entropy&cs=srgb&fm=jpg&q=85", 900),
  prismhouse: U("https://images.unsplash.com/photo-1645736353780-e70a7d508088?crop=entropy&cs=srgb&fm=jpg&q=85", 900),
  studio: U("https://images.unsplash.com/photo-1632765866070-3fadf25d3d5b?crop=entropy&cs=srgb&fm=jpg&q=85", 900),
  about: U("https://images.unsplash.com/photo-1511945863317-d60e146e9016?crop=entropy&cs=srgb&fm=jpg&q=85", 900),
  texture: U("https://images.unsplash.com/photo-1707569590646-2a51751bb9ef?crop=entropy&cs=srgb&fm=jpg&q=85", 900),
};

export const peFade = {
  hidden: { opacity: 0, y: 14 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: 0.12 * i, duration: 1, ease: "easeOut" } }),
};

export function GoldRule({ className = "", center = false }) {
  return (
    <motion.div
      aria-hidden="true"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      className={`h-px bg-pe-gold/70 ${center ? "origin-center" : "origin-left"} ${className}`}
    />
  );
}

const LEAVES = [
  [50, 62, -32], [76, 128, 24], [42, 198, -28], [78, 268, 30], [44, 342, -24], [74, 418, 26], [56, 488, -18],
];

export function Vine({ className = "", flip = false }) {
  return (
    <svg
      viewBox="0 0 120 520"
      className={`vine-sway ${className}`}
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M60 -10 C 30 70, 92 140, 60 212 C 30 282, 92 352, 60 424 C 46 462, 72 496, 60 530"
        stroke="#5A6B4C"
        strokeWidth="2.5"
        opacity="0.45"
      />
      {LEAVES.map(([cx, cy, r]) => (
        <ellipse key={`${cx}-${cy}`} cx={cx} cy={cy} rx="15" ry="6.5" fill="#5A6B4C" opacity="0.4" transform={`rotate(${r} ${cx} ${cy})`} />
      ))}
    </svg>
  );
}

export function PEHead({ overline, title, center = true, light = false }) {
  return (
    <Reveal className={`mb-14 md:mb-20 ${center ? "text-center" : ""}`}>
      <p className={`font-sans text-[11px] tracking-[0.3em] uppercase font-medium mb-5 ${light ? "text-pe-sage" : "text-pe-olive"}`}>
        {overline}
      </p>
      <h2 className={`font-pe font-normal text-3xl sm:text-4xl lg:text-5xl tracking-wide ${light ? "text-pe-ivory" : "text-pe-forest"}`}>
        {title}
      </h2>
      <GoldRule className={`w-24 mt-7 ${center ? "mx-auto" : ""}`} center={center} />
    </Reveal>
  );
}
